// по-хорошему надо импортить из "@skbkontur/fias-widget-npm-loader", но в этом случае валятся тесты на mocha, нет времени щас чинить
import * as React from "react";

export type FiasId = string;

export enum GarHouseType {
    None = "None",
    Hold = "Hold",
    House = "House",
    HouseHold = "HouseHold",
    Garage = "Garage",
    Building = "Building",
    Mine = "Mine",
    Structure = "Structure",
    Construction = "Construction",
    Litera = "Litera",
    Housing = "Housing",
    Basement = "Basement",
    BoilerRoom = "BoilerRoom",
    Cellar = "Cellar",
    UnfinishedConstruction = "UnfinishedConstruction",
}

export enum GarHouseAddType {
    None = "None",
    Structure = "Structure",
    Construction = "Construction",
    Litera = "Litera",
    Housing = "Housing",
}

export enum FiasDivision {
    Administrative = "administrative",
    Municipal = "municipal",
}

export enum FiasSchema {
    Fias = "fias",
    Gar = "gar",
}

export enum FiasEstateStatuses {
    None = "None",
    Hold = "Hold",
    House = "House",
    HouseHold = "HouseHold",
    Garage = "Garage",
    Building = "Building",
    Mine = "Mine",
    Basement = "Basement",
    BoilerRoom = "BoilerRoom",
    Cellar = "Cellar",
}
export enum FiasStructureStatuses {
    Structure = "Structure",
    Construction = "Construction",
    Liter = "Liter",
    None = "None",
}

export enum FiasLiveStatuses {
    active = "active",
    inactive = "inactive",
}

export enum FiasFlatType {
    None = 0,
    Placement = 1,
    Apartment = 2,
    Office = 3,
    Room = 4,
    WorkArea = 5,
    Stock = 6,
    ShoppingRoom = 7,
    Workshop = 8,
    Pavilion = 9,
    Basement = 10,
    BoilerRoom = 11,
    Cellar = 12,
    Garage = 13,
    CarPlace = 14,
}

export enum FiasRoomType {
    None = 0,
    Room = 1,
    Placement = 2,
}

export enum FiasFields {
    region = "region",
    district = "district",
    municipaldistrict = "municipaldistrict",
    city = "city",
    intracityarea = "intracityarea",
    urbansettlement = "urbansettlement",
    settlement = "settlement",
    planningstructure = "planningstructure",
    street = "street",
    stead = "stead",
    house = "house",
    garhouse = "garhouse",
    room = "room",
    apartment = "apartment",
}

export const ALL_FIAS_FIELDS: FiasFields[] = [
    FiasFields.region,
    FiasFields.district,
    FiasFields.municipaldistrict,
    FiasFields.city,
    FiasFields.intracityarea,
    FiasFields.urbansettlement,
    FiasFields.settlement,
    FiasFields.planningstructure,
    FiasFields.street,
    FiasFields.stead,
    FiasFields.house,
    FiasFields.garhouse,
    FiasFields.room,
    FiasFields.apartment,
];

export enum FiasExtraFields {
    postalcode = "postalcode",
}

export type FiasAllFields = FiasFields | FiasExtraFields;

export interface FiasFullValue {
    address: FiasAddressValue;
    addressString: string;
    addressErrors: FiasAddressErrors;
    fiasId: string;
    postalCode: string;
    country?: FiasCountry | undefined;
    foreignAddress?: string;
    addressWithOriginalFields?: FiasAddressValue;
    division?: FiasDivision | undefined;
}

export type FiasValue = Partial<Omit<FiasFullValue, "fiasId" | "addressString" | "division">>;

export type FiasAddressValue = {
    [key in FiasFields]?: {
        name: string;
        text: string;
        data?: FiasObject;
    };
};

export interface FiasFieldError {
    label: React.ReactNode;
    type?: string | undefined;
}

export type FiasAddressErrors = {
    [key in FiasAllFields]?: FiasFieldError;
};

export interface FiasCountry {
    shortName?: string;
    fullName?: string;
    code: string;
}

export type FiasAddressResponse = {
    [key in FiasFields]?: FiasObject;
} & {
    suggest?: {
        fiasId: string | null;
        matchResult: "MATCH" | "NOT_STRICT_MATCH";
        value: string;
    };
};

export type FiasObject = FiasAddressObject | FiasStead | FiasHouse | GarHouse | FiasRoom;
export interface FiasEntity {
    id: string;
    fiasId: FiasId;
    level?: string;
    parentFiasId?: FiasId;
    parentFiasIds?: FiasId[];
    postalCode?: string;
    okato?: string;
    oktmo?: string;
    ifnsfl?: string;
    ifnsul?: string;
}
export interface FiasAddressObject extends FiasEntity {
    name: string;
    official: string;
    abbreviation: string;
    code?: string;
}
export interface FiasStead extends FiasEntity {
    number: string;
    liveStatus: FiasLiveStatuses;
}
export interface FiasHouse extends FiasEntity {
    estateStatus: FiasEstateStatuses;
    structureStatus: FiasStructureStatuses;
    number?: string;
    structureNumber?: string;
    buildingNumber?: string;
}
export interface GarHouse extends FiasEntity {
    houseNum?: string;
    houseType?: GarHouseType;
    addNum1?: string;
    addType1?: GarHouseAddType;
    addNum2?: string;
    addType2?: GarHouseAddType;
    houseAbbreviation?: string;
    addAbbreviation1?: string;
    addAbbreviation2?: string;
}
export interface FiasRoom extends FiasEntity {
    flatNumber: string;
    flatType: FiasFlatType;
    liveStatus: FiasLiveStatuses;
    flatFiasId?: FiasId;
    roomNumber?: string;
    roomType?: FiasRoomType;
    flatAbbreviation: string;
}
